// components/FileUploader.tsx
import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useUploadFileMutation } from "../../api/file";
import { Box, Button, TextField, Typography } from "@mui/material";
import { Link as RLink } from "react-router-dom";
import Link from "@mui/material/Link";
const FileUploader: React.FC<{ id: string }> = ({ id }) => {
    const [file, setFile] = useState<File | null>(null);
    const [title, setTitle] = useState("");
    const [uploadFile, { isLoading, isSuccess, isError, error, data }] =
        useUploadFileMutation();

    const onDrop = useCallback((acceptedFiles: File[]) => {
        if (acceptedFiles.length > 0) {
            setFile(acceptedFiles[0]);
        }
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
    });

    const handleUpload = () => {
        if (file) {
            uploadFile({ id, file, title });
        }
    };

    return (
        <Box>
            <Box
                {...getRootProps()}
                sx={{
                    border: "2px dashed #ccc",
                    padding: 4,
                    textAlign: "center",
                    mb: 2,
                    cursor: "pointer",
                }}
            >
                <input {...getInputProps()} />
                <Typography>
                    {isDragActive
                        ? "Drop the file here..."
                        : "Drag & drop a file here, or click to select"}
                </Typography>
            </Box>

            {file && <Typography>Selected file: {file.name}</Typography>}

            <TextField
                label="Title"
                fullWidth
                margin="normal"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
            />

            <Button
                variant="contained"
                disabled={!file || isLoading}
                onClick={handleUpload}
            >
                Upload
            </Button>
            {isLoading && (
                <div style={{ marginTop: 12 }}>
                    <div>Uploading…</div>
                    <div
                        className="progress"
                        style={{
                            height: 6,
                            background: "#eee",
                            borderRadius: 999,
                        }}
                    >
                        <div
                            style={{
                                width: "100%",
                                height: "100%",
                                background: "#999",
                                borderRadius: 999,
                                animation: "pulse 1s infinite",
                            }}
                        />
                    </div>
                </div>
            )}
            {isSuccess && data && (
                <div style={{ marginTop: 12, color: "green" }}>
                    {Object.values(data?.items).map((fi) => (
                        <>
                            ✅ Upload complete
                            <Link
                                component={RLink}
                                to={"/file/view/" + fi.metadata.id}
                            >
                                (check: )
                            </Link>
                            <br />
                        </>
                    ))}
                </div>
            )}
            {isError && (
                <div style={{ marginTop: 12, color: "crimson" }}>
                    ❌ Upload failed:{" "}
                    {String(
                        (error as any)?.data ||
                            (error as any)?.error ||
                            "Unknown error",
                    )}
                </div>
            )}
        </Box>
    );
};

export default FileUploader;

/*
// src/components/FileUploader.tsx
import React from 'react';
import { useDropzone } from 'react-dropzone';
import { Box, Typography, Paper, Snackbar, Alert } from '@mui/material';
import { useUploadFileMutation } from '../../api/file';

const FileUploader: React.FC = () => {
  const [uploadFile, { isLoading, isSuccess, isError }] = useUploadFileMutation();
  const [openSnackbar, setOpenSnackbar] = React.useState(false);

  const onDrop = React.useCallback((acceptedFiles: File[]) => {
    if (acceptedFiles.length > 0) {
      uploadFile(acceptedFiles[0]);
      setOpenSnackbar(true);
    }
  }, [uploadFile]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <Box>
      <Paper
        {...getRootProps()}
        sx={{
          p: 4,
          border: '2px dashed #1976d2',
          textAlign: 'center',
          backgroundColor: isDragActive ? '#e3f2fd' : '#f5f5f5',
          cursor: 'pointer',
        }}
      >
        <input {...getInputProps()} />
        <Typography variant="h6">
          {isDragActive ? 'Drop the file here...' : 'Drag & drop a file here, or click to select'}
        </Typography>
      </Paper>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
      >
        {isSuccess ? (
          <Alert severity="success" onClose={() => setOpenSnackbar(false)}>
            File uploaded successfully!
          </Alert>
        ) : isError ? (
          <Alert severity="error" onClose={() => setOpenSnackbar(false)}>
            File upload failed.
          </Alert>
        ) : undefined}
      </Snackbar>
    </Box>
  );
};

export default FileUploader;
// */
